import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkNa } from "../shared/templates";

const app = window.app;

export class MbFunctions extends HTMLElement {
	async connectedCallback() {
		//this.innerHTML = "<ion-content><h2>It works!</h2></ion-content>";
		await waitForContent("mbFunction");

		this.innerHTML = app.content.mbFunction;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton14", "nextButton14"));

		//prettier-ignore
		const questions = [
			["mer-headlights",       "Headlights and taillights",        false],
			["mer-turn-signals",     "Turn signals and hazard lights",   false],
			["mer-reverse-lights",   "Reverse lights",                   false],
			["mer-plate-lights",     "License plate illumination",       false],
			["mer-horn",             "Horn",                             false],
			["mer-windows",          "Window up/down",                   false],
			["mer-sunroof",          "Sunroof and sunshade",              true],
			["mer-trunk",            "Power tailgate/trunk",             true ],
			["mer-ev-cable",         "EV charging cables present",       true ],
			["mer-charge-card",      "ChargePoint card functional",      true ],
			["mer-cluster-lights",   "Cluster illumination",             false],
			["mer-dome-lights",      "Dome lamps",                       false],
			["mer-steering-buttons", "Steering wheel buttons",           false],
			["mer-steering-adjust",  "Adjustable steering column",       false],
			["mer-steering-heat",    "Heated steering wheel",            false],
			["mer-seats-electric",   "Electric seats",                   false],
			["mer-seats-heat",       "Heated/cooled seats",              false],
			["mer-seats-massage",    "Massage seats",                    false],
			["mer-seatbelts",        "Seatbelt height adjuster",         false],
		];

		for (const [name, label, na] of questions) {
			const render = na ? renderQuestionOkNotOkNa : renderQuestionOkNotOk;
			this.querySelector(`#${name}-slot`).replaceWith(render(name, label, 14));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(14, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			const currentRoute = app.routes.mbFunction;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
